import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";

const RejectCommentModal = ({
  open,
  onClose,
  onSubmit,
  workflowId,
  requester,
  requesterId,
}) => {
  const [notes, setNotes] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  // Access Redux state
  const workflowRoute = useSelector((state) => state.workflowRoutes || {});
  const workflowRouteActors = useSelector(
    (state) => state.workflowRoutes?.workflowRouteActors || [],
  );

  // Debug logs for initial props and state
  useEffect(() => {
    console.log("QueryModal mounted with props:", {
      workflowId,
      requester,
      requesterId,
    });
    console.log("Redux state - workflowRoute:", workflowRoute);
    console.log("Redux state - workflowRouteActors:", workflowRouteActors);
  }, [workflowId, requester, requesterId, workflowRoute, workflowRouteActors]);

  // Handle form submission
  const handleSubmit = () => {
    if (!notes) {
      console.error("Submit attempted with no notes");
      return;
    }

    const fullNotes = `${notes}`;
    onSubmit({ notes: fullNotes });

    // Reset and close
    setNotes("");
    setSelectedOption("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Reject Notes</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Notes"
          fullWidth
          multiline
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          sx={{ mb: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={!notes}
          variant="contained"
        >
          Submit Comment
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectCommentModal;
